import { config } from '~shared/config';

export const getAwsWafDomains = () => {
  const apiHost = config.apiHost.includes('/api-proxy')
    ? 'https://portal-api-test.breezeventures.io'
    : config.apiHost;
  const apiDomain = new URL(apiHost).hostname;
  const domains: string[] = [apiDomain];

  if (typeof window !== 'undefined') {
    domains.push(window.location.hostname);
  }

  return domains;
};
